import { gql } from 'graphql-request';

const lineageAssetNodeFields = `
  __typename
  id
  parentId
  level
  type
  sourceType
  displayType
  artifactType
  name
  tags
  owners
  path
  columnsCount
  ... on TableAsset {
    dataPlatform
    dbName
    schemaName
    tableName
    materialization
    latestTestExecutions {
      test {
        name
      }
      execution {
        status
        columnName
      }
    }
  }
  ... on BiAsset {
    platform
    biType
  }
  ... on SemanticAsset {
    platform
    semanticType
  }
`;

const lineageColumnNodeFields = `
  ... on Asset {
    __typename
    id
    parentId
    level
    type
    name
    artifactType
    displayType
    tags
    owners
    path
    ... on ColumnAsset {
      displayName
    }
  }
`;

export const getLineageAssetsQuery = gql`
  query GetLineageAssets(
    $assetIds: [String!]! = []
    $columnIds: [String!] = null
    $downstreamHops: Int = 1
    $upstreamHops: Int = 1
    $perParentColumnsLimit: Int = null
  ) {
    lineage(
      filters: {
        assetIds: $assetIds
        columnIds: $columnIds
        downstreamHops: $downstreamHops
        upstreamHops: $upstreamHops
        perParentColumnsLimit: $perParentColumnsLimit
      }
    ) {
      assets {
        nodes {
          ${lineageAssetNodeFields}
        }
        edges {
          dst
          src
        }
        boundaries {
          downstream
          upstream
        }
      }
    }
  }
`;

export const getColumnLineageQuery = gql`
  query GetColumnLineage(
    $assetIds: [String!]! = []
    $columnIds: [String!] = null
    $downstreamHops: Int = 1
    $upstreamHops: Int = 1
    $perParentColumnsLimit: Int = null
  ) {
    lineage(
      filters: {
        assetIds: $assetIds
        columnIds: $columnIds
        downstreamHops: $downstreamHops
        upstreamHops: $upstreamHops
        perParentColumnsLimit: $perParentColumnsLimit
      }
    ) {
      assets {
        nodes {
          ${lineageAssetNodeFields}
        }
        edges {
          dst
          src
        }
        boundaries {
          downstream
          upstream
        }
      }
      columns {
        nodes {
          ${lineageColumnNodeFields}
        }
        edges {
          dst
          src
        }
        boundaries {
          downstream
          upstream
        }
        exceededLimitParentAssets
      }
    }
  }
`;

/** @deprecated Use getLineageAssetsQuery or getColumnLineageQuery instead */
export const getLineageQuery = getColumnLineageQuery;

export const getAssetColumnsQuery = gql`
  query GetAssetColumns($assetId: String!) {
    asset(id: $assetId) {
      id
      columns {
        id
        parentId
        level
        type
        name
        artifactType
        displayType
        tags
        owners
        path
        ... on ColumnAsset {
          displayName
        }
      }
    }
  }
`;

export const getAssetTestResultsQuery = gql`
  query GetAssetTestResults($assetId: String!) {
    latestTestExecutions(filters: { assetIds: [$assetId] }) {
      test {
        id
        name
        type
        tags
      }
      execution {
        subType
        subTestUniqueId
        status
        executionTimestamp
        columnName
        qualityDimension
      }
    }
  }
`;
